import React from "react";
import {t} from "i18next";

const ShopProduct = ({ products, onProductClick, addToCartProduct }) => {

  return (
    <div className="shop-grids">
      {products.length > 0 &&
        products.map((product, i) => (
          <div className="grid" key={i}>
            <div className="img-holder" onClick={() => onProductClick(product)}>
              <img src={product.image} alt={product.name} />
            </div>
            <div className="details">
              <h3 onClick={() => onProductClick(product)}>{product.name}</h3>
              <p>{product.description}</p>
              <button
                className="theme-btn-s5"
                onClick={() => onProductClick(product)}
              >
                {t('Price.details')}
              </button>
            </div>
          </div>
        ))}
    </div>
  );
};

export default ShopProduct;
